import apiClient from './apiClient';

export async function submitLead(payload) {
  const response = await apiClient.post('/api/leads', payload);
  return response.data;
}
